import { render, staticRenderFns } from "./examSubjectDetails.html?vue&type=template&id=71e4958f&external"
import script from "./examSubjectDetails.vue?vue&type=script&lang=js"
export * from "./examSubjectDetails.vue?vue&type=script&lang=js"
import style0 from "./examSubjectDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports